import React from "react";
import SelectRequestReference from "./list_request";

class PageReferences extends React.Component {
  render() {
    return (
      <React.Fragment>
        {this.props.data.map((item, i) =>
          item.key === 'incomeReferenceReqAvailable' ?
            <SelectRequestReference
              visibility={item.value}
              key={i}
              title="Справка о доходах"
              label="Выберите год и получите справку о доходах."
              link="income/reference/"/>
            :
            <SelectRequestReference
              visibility={item.value}
              key={i}
              title="Справка о постановке на учет"
              label="Выберите год и получите справку о постановке на учет."
              link="client/registration/reference/"/>
        )}
      </React.Fragment>
    )
  }
}

export default PageReferences;